var __typeError = (msg) => {
  throw TypeError(msg);
};
var __accessCheck = (obj, member, msg) => member.has(obj) || __typeError("Cannot " + msg);
var __privateGet = (obj, member, getter) => (__accessCheck(obj, member, "read from private field"), getter ? getter.call(obj) : member.get(obj));
var __privateAdd = (obj, member, value) => member.has(obj) ? __typeError("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
var _STORAGE_KEY, _MAX_PRODUCTS;
class RecentlyViewed {
  /**
   * Adds a product to the recently viewed products list.
   * @param {string} productId - The ID of the product to add.
   */
  static addProduct(productId) {
    let viewedProducts = this.getProducts();
    viewedProducts = viewedProducts.filter((id) => id !== productId);
    viewedProducts.unshift(productId);
    viewedProducts = viewedProducts.slice(0, __privateGet(this, _MAX_PRODUCTS));
    localStorage.setItem(__privateGet(this, _STORAGE_KEY), JSON.stringify(viewedProducts));
  }
  static clearProducts() {
    localStorage.removeItem(__privateGet(this, _STORAGE_KEY));
  }
  /**
   * Retrieves the list of recently viewed products from session storage.
   * @returns {string[]} The list of viewed products.
   */
  static getProducts() {
    return JSON.parse(localStorage.getItem(__privateGet(this, _STORAGE_KEY)) || "[]");
  }
}
_STORAGE_KEY = new WeakMap();
_MAX_PRODUCTS = new WeakMap();
/** @static @constant {string} The key used to store the viewed products in session storage */
__privateAdd(RecentlyViewed, _STORAGE_KEY, "viewedProducts");
/** @static @constant {number} The maximum number of products to store */
__privateAdd(RecentlyViewed, _MAX_PRODUCTS, 4);
export {
  RecentlyViewed
};
